import { RootState } from 'store';
import { IUserProfileResponse, IUserReducer } from 'types';

export const getUserProfileSelector = (store: RootState): IUserProfileResponse | null => store.user.data || null;

export const getUserIsLoadingSelector = (store: RootState): boolean => store.user.isLoading;

export const getUserReducerSelector = (store: RootState): IUserReducer => store.user;
